import { Component, inject, OnInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import {
    piIconAddUser,
    piIconEllipsisBold,
    piIconTrash
} from '@predictiveindex/pi-client-icons';
import {
    IconSize,
    TapestryIconButtonModule,
    TapestryIconModule,
    TapestryIconRegistryService
} from '@predictiveindex/tapestry';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SellerToolsAccountTableData } from '../../../../../core-data-model';
import {
    FeatureFlags,
    FeatureFlagsService
} from '../../../../../system-services';
import { TranslationsModule } from '../../../../../translations';

@Component({
    selector: 'action-menu',
    imports: [
        TapestryIconButtonModule,
        MatMenuModule,
        TapestryIconModule,
        TranslationsModule
    ],
    templateUrl: './action-menu.component.html',
    styleUrls: ['./action-menu.component.less']
})
export class ActionMenuComponent implements ICellRendererAngularComp, OnInit {
    enableAddThirdPartyUsers = false;

    params: ICellRendererParams<SellerToolsAccountTableData>;

    protected readonly IconSize = IconSize;

    private readonly tapestryIconRegistry = inject(TapestryIconRegistryService);
    private readonly featureFlags = inject(FeatureFlagsService);

    ngOnInit() {
        this.tapestryIconRegistry.registerIcons([
            piIconEllipsisBold,
            piIconTrash,
            piIconAddUser
        ]);

        this.enableAddThirdPartyUsers = this.featureFlags.getByFlag(
            FeatureFlags.enableAddThirdPartyUsers
        );
    }

    agInit(params: ICellRendererParams<SellerToolsAccountTableData>) {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }

    deleteAccount() {
        this.params.context.deleteAccountConfirmation(this.params.data);
    }

    addThirdPartyUsers() {
        this.params.context.addThirdPartyUsers(this.params.data);
    }
}
